import SelectedFilterPopup from './components/SelectedFilterPopup';
import FilterListSection from './FilterListSection';
import SelectedOptionsSection from './SelectedOptionsSection';

const ListingPageDesktopFilterComponent = ({
  filterOptions,
  selectedFilterCategory,
  setSelectedFilterCategory,
  filterData,
  collegesUrl,
  location,
  availableStreams,
  filterSecStreamData,
  filterSpecialization,
  filterPopupRef,
}: any) => {
  return (
    <div className="flex w-full flex-col gap-y-1">
      <div className="flex items-center justify-center gap-x-0.5">
        <h3 className={`hidden font-inter text-sm text-gray-500 lg:block`}>Filter By</h3>
        {/* <Image src={FilterBy} alt="Filter Icon" width={20} height={20} /> */}
        <div className="ml-2 mr-4 h-6 w-px bg-gray-400"></div>
        <div className="flex flex-1 flex-col gap-y-2">
          {/* list of types of filters */}
          <FilterListSection
            filterOptions={filterOptions}
            setSelectedFilterCategory={setSelectedFilterCategory}
            selectedCategory={selectedFilterCategory} // <-- Pass this prop
          />
          <div ref={filterPopupRef}>
            <SelectedFilterPopup
              filterData={filterData}
              selectedFilterCategory={selectedFilterCategory}
              setSelectedFilterCategory={setSelectedFilterCategory}
              filterOptions={filterOptions}
              collegesUrl={collegesUrl}
              location={location}
              filterSecStreamData={filterSecStreamData}
              availableStreams={availableStreams}
              filterSpecialization={filterSpecialization}
            />
          </div>
        </div>
      </div>
      {/* here print a list in a straight line */}
      <SelectedOptionsSection
        filterOptions={filterOptions}
        collegesUrl={collegesUrl}
        location={location}
        setSelectedFilterCategory={setSelectedFilterCategory}
      />
    </div>
  );
};

export default ListingPageDesktopFilterComponent;
